import { useTranslation } from "react-i18next";
import { VovClient, WeatherInfoDTO } from "../../../ApiOld/ApiServerVov";
import { useEffect, useMemo, useState } from 'react';
import ProjectWeatherItem from './Components/ProjectWeatherItem';
import { Grid } from "@mui/material";
import { useApi } from "../../../ApiOld/Api/useApi";
import { groupBy } from "../../Shared/GroupBy";

interface ProjectWeatherSceneProps {
    projectId: number | undefined;
}

export default function ProjectWeatherScene(props: ProjectWeatherSceneProps) {
    const { projectId } = props;
    const { t, i18n } = useTranslation();
    const { authorizedApi } = useApi(VovClient);
    const [weather, setWeather] = useState<WeatherInfoDTO[] | null>(null);

    useEffect(() => {
        if (!projectId) {
            return;
        }
        authorizedApi.getBuildingWeather(projectId).then((res) => {
            setWeather(res.weather ?? []);
        });
    }, [projectId]);

    const groupedWeather = useMemo(() => {
        const data = groupBy(weather ?? [], i => i.date === undefined ? "" : i.date);

        let tmp: any[] = [];
        for (const b in data) {
            tmp?.push([b, data[b]])
        }
        return tmp;
    }, [weather]);

    return (
        <Grid container style={{ minWidth: '400px' }} spacing={2}>
            {groupedWeather.map(([date, weathers], index) => (
                <Grid item xs={12} md={6} lg={4} key={index}>
                    <ProjectWeatherItem key={'weather_' + index} weather={weathers} date={date} />
                </Grid>
            ))}
        </Grid>
    );
}
